import { render, staticRenderFns } from "./entity-boxes.vue?vue&type=template&id=16d923b2"
import script from "./entity-boxes.vue?vue&type=script&lang=js"
export * from "./entity-boxes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports